
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCommandLockedF as ObiCommandLockedFElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-command-locked-f.js';
 
 
 

 
 export const ObiCommandLockedF = createComponent({
   react: React,
   tagName: 'obi-command-locked-f',
   elementClass: ObiCommandLockedFElement,
   events: {
     
   }
  });
 
 